import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-rain-icon',
  imports: [
    NgOptimizedImage,
  ],
  templateUrl: './rain-icon.component.html',
  styleUrl: './rain-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RainIconComponent {
  rainLastHour = input<number>();

  rainIcon = computed(() => {
    let rainIndex = 0;

    const scale = [1, 5, 50, Infinity];

    // Return the first index of the value greater than the given value
    for (let i = 0; i < scale.length; i++) {
      if (this.rainLastHour() <= scale[i]) {
        rainIndex = i;
        break;
      }
    }

    return `/assets/rain/rain-${rainIndex}.svg`;
  });
}
